import { CommonModule } from '@angular/common';
import { Component, computed, input, output, TemplateRef, viewChild, ViewChild } from '@angular/core';

import { IPaginationResponseResolver, IPaginationParameters } from '../../../data-access';
import { IActionConfig, IActionExecutedEvent, IDialogConfig, ITableConfig } from '../../../ui';
import { IAuditableLookup } from '../../../primitives';
import { AuditableEntitiesComponent } from '../../../entities';

@Component({
  selector: 'app-auditable-lookups',
  standalone: true,
  providers: [],
  imports: [CommonModule, AuditableEntitiesComponent],
  templateUrl: './auditable-lookups.component.html',
  styleUrls: ['./auditable-lookups.component.scss']
})
export class AuditableLookupsComponent<
  TEntity extends IAuditableLookup<string>,
  TPaginationParameters extends IPaginationParameters
> {
  tableRowTemplate = viewChild.required<TemplateRef<{ $implicit: TEntity }>>('tableRowTemplate');
  paginationResponseResolver = input.required<IPaginationResponseResolver<TEntity, TPaginationParameters>>();
  defaultPaginationParameters = input.required<TPaginationParameters>();
  supportedActions = input.required<IActionConfig<TEntity>[]>();
  tableConfig = input<ITableConfig>();
  actionExecuted = output<IActionExecutedEvent<TEntity>>();

  finalTableConfig = computed(() => ({
    fields: [{ name: 'englishName', displayName: 'GENERAL.ENGLISH_NAME' }, ...(this.tableConfig()?.fields ?? [])],
    template: this.tableRowTemplate()
  }));

  onActionExecuted(event: unknown) {
    this.actionExecuted.emit(event as IActionExecutedEvent<TEntity>);
  }
}
